export const administrationAccountsSiteLocationEmployees = {
    template: require('./administration-accounts-site-location-employees.html'),
    controller: 'AdministrationAccountsSiteLocationEmployeesController'
};
